/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Spaces_TitleInputs */

const en_of_landing_spaces_title = /** @type {(inputs: Of_Landing_Spaces_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaces that fit your team`)
};

const id_of_landing_spaces_title = /** @type {(inputs: Of_Landing_Spaces_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang sesuai cara kerjamu`)
};

/**
* | output |
* | --- |
* | "Spaces that fit your team" |
*
* @param {Of_Landing_Spaces_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_spaces_title = /** @type {((inputs?: Of_Landing_Spaces_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Spaces_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_spaces_title(inputs)
	return en_of_landing_spaces_title(inputs)
});